import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { OCCUPATION_CANDIDATES } from '../../../define/consts/profile';
import { propShape, propStr } from '../../../helpers/custom-prop-types';
import { getFormErrorsFirst, getFormValue } from '../../../helpers/form';
import { validateOccupation, validateOccupationOther, } from '../../../validate/profile';
import PlainInputField from '../Common/Fields/PlainInputField';
import SelectField from '../Common/Fields/SelectField';
import InputError from '../Common/InputError';
const viewPosition = [{ label: '---', value: '' }, ...OCCUPATION_CANDIDATES];
const OccupationFieldsAndLabel = (props) => {
    const { form, name, nameOther } = props;
    const error = getFormErrorsFirst(form, [name, nameOther]);
    const positionValue = getFormValue(form, name);
    const isOther = positionValue ===
        OCCUPATION_CANDIDATES.find((p) => !!p.other).value.toString();
    return (_jsxs("div", Object.assign({ className: 'form form-solution req' }, { children: [_jsx("h3", { children: "\u8077\u7A2E" }), _jsxs("div", Object.assign({ className: 'form-flex-split is-half-form' }, { children: [_jsx("div", Object.assign({ className: 'input-form-select' }, { children: _jsx(SelectField, { className: 'form-solution-select set-option-height', name: name, options: viewPosition, validate: validateOccupation }) })), _jsx(PlainInputField, { className: 'input-form-text asign-state', disabled: !isOther, name: nameOther, showError: false, validate: isOther ? validateOccupationOther : [] })] })), _jsx(InputError, { error: error })] })));
};
OccupationFieldsAndLabel.propTypes = {
    form: propShape().isRequired,
    name: propStr().isRequired,
    nameOther: propStr().isRequired,
};
export default OccupationFieldsAndLabel;
